import { ChartTypes } from '@mode/shared/contract-common';
import { financialFormatter, numberFormatter, percentFormatter } from '@mode/shared/util-js';
import { FieldFormatHelpers } from '..';

export function getFormatterByType(
  formatType: ChartTypes.FormatType
): (value: any, formatOptions: any) => number | string {
  switch (formatType) {
    case ChartTypes.FormatType.Number:
      return numberFormatter;
    case ChartTypes.FormatType.Percent:
      return percentFormatter;
    case ChartTypes.FormatType.Financial:
      return financialFormatter;
    case ChartTypes.FormatType.Default:
      return defaultFormatter;
    default:
      return defaultFormatter;
  }
}

export function defaultFormatter(value: number | string, formatOptions?: ChartTypes.TextFormat): number | string {
  let num = Number(value);
  const negativeCoefficient = num < 0 ? -1 : 1;
  num = Math.abs(num);
  const isQuadrillions = num >= 1e15;
  const isTrillions = num >= 1e12;
  const isBillions = num >= 1e9;
  const isThousands = num >= 1e3;
  const isMillions = num >= 1e6;
  const getNum = (num: number, multiplier: number) =>
    ((num - (num % multiplier)) / multiplier + (num % multiplier) / multiplier) * negativeCoefficient;
  const formatter = (multiplier: number, suffix: ChartTypes.DisplayUnit): string => {
    if (num % multiplier && num % multiplier !== num) {
      if (num / (multiplier * 1e2) >= 1) {
        return getNum(num, multiplier).toFixed(0) + suffix;
      } else if (num / (multiplier * 1e1) >= 1) {
        return getNum(num, multiplier).toFixed(1) + suffix;
      } else if (num / multiplier >= 1) {
        return getNum(num, multiplier).toFixed(1) + suffix;
      }
    } else {
      return negativeCoefficient * (num / multiplier) + suffix;
    }
    return num.toString();
  };

  return isQuadrillions
    ? formatter(1e15, 'Q')
    : isTrillions
    ? formatter(1e12, 'T')
    : isBillions
    ? formatter(1e9, 'B')
    : isMillions
    ? formatter(1e6, 'M')
    : isThousands
    ? formatter(1e3, 'K')
    : num % 1
    ? (num * negativeCoefficient).toFixed(1)
    : num * negativeCoefficient;
}

export function getPaneTextFormat(fieldFormats: ChartTypes.FieldFormatMap, formula: string) {
  if (fieldFormats != null) {
    const fieldFormat = fieldFormats[formula];
    if (fieldFormat != null) {
      return fieldFormat.paneFormat[ChartTypes.FieldPaneTypes.Default] || FieldFormatHelpers.makeDefaultTextFormat();
    }
  }

  return FieldFormatHelpers.makeDefaultTextFormat();
}
